module.exports = __webpack_public_path__ + "static/media/loading.63eb7825.gif";